import { render, staticRenderFns } from "./LogementTypeChart.vue?vue&type=template&id=74bf25a4&"
import script from "./LogementTypeChart.vue?vue&type=script&lang=js&"
export * from "./LogementTypeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports